import { useLanguage } from '@/contexts/LanguageContext';

export function DemoIndicator() {
  const { t } = useLanguage();
  
  return (
    <div className="text-center py-1">
      <span className="text-xs text-muted-foreground">
        {t('demoIndicator')}
      </span>
    </div>
  );
}
